import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { FiClipboard, FiUsers, FiShield } from "react-icons/fi";
import toast from "react-hot-toast";
<img src="/logo.jpg" alt="logo" />


const StatItem = ({ icon, text }) => (
  <div className="flex items-center space-x-3 bg-white/10 rounded-lg p-3 backdrop-blur-sm">
    <span className="text-2xl">{icon}</span>
    <span className="text-sm font-medium">{text}</span>
  </div>
);

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    accountType: "user",
    fullName: "",
    phone:"",
    email: "",
    password: "",
    confirmPassword: "",
    address: "",
    city: "",
    pincode: "",
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const MAX_LENGTHS = {
    fullName: 50,
    phone:10,
    email: 50,
    password: 20,
    confirmPassword: 20,
    address: 50,
    city: 50,
    pincode: 6,
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // 🚫 Block spaces in password fields
    if (name === "password" || name === "confirmPassword") {
      newValue = value.replace(/\s/g, "");
    }

    // 🚫 Block password longer than 20 chars
    if (
      (name === "password" || name === "confirmPassword") &&
      newValue.length > 20
    ) {
      setErrors((p) => ({
        ...p,
        [name]: "Password cannot exceed 20 characters",
      }));
      return; // ⛔ stop updating state
    }

    if (
      name === "password" &&
      errors.password === "copy & paste is not allowed"
    ) {
      setErrors((prev) => ({ ...prev, password: "" }));
    }
    
    if(name==="confirmpassword" &&
      errors.confirmPassword === "copy & paste is not allowed"
    ){
      setErrors((prev)=>({...prev,confirmPassword:""}));
    }
    // Clear length error if valid
    if (errors[name]) {
      setErrors((p) => ({ ...p, [name]: "" }));
    }

    // Full name rule
    if (name === "fullName") {
      const cleaned = newValue.replace(/[^A-Za-z\s]/g, "");
      setFormData({ ...formData, fullName: cleaned });
      return;
    }

    setFormData({ ...formData, [name]: newValue });

    // Password validation message
    if (name === "password") {
      setErrors((p) => ({
        ...p,
        password: /\s/.test(value) ? "Password must not contain spaces" : "",
      }));
    }

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // FULL NAME VALIDATION
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
    } else if (formData.fullName.trim().length < 3) {
      newErrors.fullName = "Full name must be at least 3 characters";
    }

    const emailRegex = /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@gmail\.com$/;
    const phoneRegex=/^(?:\+91[-\s]?)?[6-9]\d{9}$/

    const phone = formData.phone.trim();

if (!phone) {
  newErrors.phone = "Phone Number is required";
} else if (!phoneRegex.test(phone)) {
  newErrors.phone = "Enter a valid Phone Number";
}


    const email = formData.email.trim().toLowerCase();
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email address (example:user@gmail.com)";
    }
   

    // PASSWORD VALIDATION
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (/\s/.test(formData.password)) {
      newErrors.password = "Password must not contain spaces";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    } else if (formData.password.length > 20) {
      newErrors.password = "Password cannot exceed 20 characters";
    } else if (!/[A-Z]/.test(formData.password)) {
      newErrors.password = "Password must contain at least 1 uppercase letter";
    } else if (!/[0-9]/.test(formData.password)) {
      newErrors.password = "Password must contain at least 1 number";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.password)) {
      newErrors.password = "Password must contain at least 1 special character";
    }

    // CONFIRM PASSWORD VALIDATION
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm password";
    } else if (/\s/.test(formData.confirmPassword)) {
      newErrors.confirmPassword = "Confirm password must not contain spaces";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    } else if (!/[A-Z]/.test(formData.confirmPassword)) {
      newErrors.confirmPassword =
        "Password must contain at least 1 uppercase letter";
    } else if (!/[0-9]/.test(formData.confirmPassword)) {
      newErrors.confirmPassword = "Password must contain at least 1 number";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(formData.confirmPassword)) {
      newErrors.confirmPassword =
        "Password must contain at least 1 special character";
    }

    if (formData.accountType === "purohit") {
     if (!formData.address.trim()) {
  newErrors.address = "Address is required";
} else if (formData.address.trim().length < 5) {
  newErrors.address = "Address must be at least 5 characters";
} else if (!/^[A-Za-z0-9\s,.-]+$/.test(formData.address.trim())) {
  newErrors.address =
    "Address can contain only letters, numbers, spaces, commas, dots, and dashes";
}


      if (!formData.city.trim()) {
        newErrors.city = "City is required";
      } else if (!/^[A-Za-z\s]{3,50}$/.test(formData.city.trim())) {
        newErrors.city = "City name must be 3-50 letters only";
      }

      if (!formData.pincode) {
        newErrors.pincode = "PIN code is required";
      } else if (!/^[1-9][0-9]{5}$/.test(formData.pincode)) {
        newErrors.pincode = "PIN code must be 6 digits and cannot start with 0";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Navigate to agreement page with form data
    navigate("/agreement", {
      state: {
        formData: formData,
      },
    });
  };

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-orange-50 to-amber-50 flex items-start justify-center px-3 pb-3 sm:px-4 sm:pb-4"
      style={{ paddingTop: "80px" }}
    >
      <div className="w-full max-w-6xl bg-white rounded-xl shadow-md overflow-hidden flex flex-col md:flex-row mt-4 mb-10">
        {/* LEFT SIDE */}
        <div className="hidden md:flex bg-gradient-to-br from-red-500 to-orange-500 text-white p-8 md:w-2/5 flex-col justify-center">
          <div className="mb-6 flex justify-center">
            <div className="w-24 h-24 rounded-full shadow-xl bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center flex-shrink-0">
              <img
                src="/logo.jpg"
                className="w-16 h-16 rounded-full border-4 border-yellow-300 shadow-[0_0_15px_5px_rgba(255,200,0,0.7)]"
                alt="logo"
             />

            </div>
          </div>

          <h1 className="text-3xl xl:text-4xl font-serif font-bold mb-3">
            Welcome to Purohit App
          </h1>

          <p className="text-base xl:text-lg text-orange-100 mb-6">
            Sacred Services, Delivered with Devotion
          </p>

          <div className="space-y-3">
            <StatItem icon={<FiClipboard />} text="2000+ Verified Purohits" />
            <StatItem icon={<FiUsers />} text="50,000+ Families Served" />
            <StatItem icon={<FiShield />} text="100% Secure & Trusted" />
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="p-6 md:p-10 w-full md:w-3/5 flex items-start justify-center md:-mt-6">
          <div className="w-full max-w-sm md:min-h-[560px]">
            <h2 className="text-xl md:text-2xl font-semibold text-gray-800 text-center mb-6">
              Create Account
              <p className="text-sm text-gray-500 mt-1">
                Join our spiritual journey
              </p>
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* ACCOUNT TYPE */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Account Type
                </label>
                <select
                  name="accountType"
                  value={formData.accountType}
                  onChange={handleChange}
                  className="w-full text-sm px-4 py-2.5 border border-gray-300 rounded-lg"
                >
                  <option value="user">User</option>
                  <option value="purohit">Purohit</option>
                  <option value="temple">Temple Seva</option>
                </select>
              </div>

              {/* FULL NAME */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  maxLength={50}
                  placeholder="Enter your full name"
                  className={`w-full px-4 py-2.5 border ${
                    errors.fullName ? "border-red-300" : "border-gray-300"
                  } rounded-lg`}
                />
                <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                  {errors.fullName || "\u00A0"}
                </p>
              </div>

               <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  maxLength={10}
                  placeholder="Enter your phone number"
                  className={`w-full px-4 py-2.5 border ${
                    errors.fullName ? "border-red-300" : "border-gray-300"
                  } rounded-lg`}
                />
                <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                  {errors.phone || "\u00A0"}
                </p>
              </div>

              {/* EMAIL */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="text"
                  inputMode="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  maxLength={50}
                  placeholder="Enter your email"
                  className={`w-full px-4 py-2.5 border ${
                    errors.email ? "border-red-300" : "border-gray-300"
                  } rounded-lg`}
                />
                <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                  {errors.email || "\u00A0"}
                </p>
              </div>

              {/* PASSWORD + CONFIRM PASSWORD */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* PASSWORD */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Password *
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      onCopy={(e) => {
                        e.preventDefault();
                        setErrors((prev) => ({
                          ...prev,
                          password: "copy is not allowed for security resons",
                        }));
                      }}
                      onCut={(e) => {
                        e.preventDefault();
                        setErrors((prev) => ({
                          ...prev,
                          password: "Cut is not allowed for security reasons",
                        }));
                      }}
                      onPaste={(e) => {
                        e.preventDefault();
                        setErrors((prev) => ({
                          ...prev,
                          password: "Copy & paste is not allowed",
                        }));
                      }}
                      onDrop={(e) => e.preventDefault()}
                      autoComplete="new-password"
                      maxLength={20}
                      placeholder="Enter password"
                      className={`w-full px-2 py-2.5 pr-10 border ${
                        errors.password ? "border-red-300" : "border-gray-300"
                      } rounded-lg`}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                  <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                    {errors.password || "\u00A0"}
                  </p>
                </div>

                {/* CONFIRM PASSWORD */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Confirm Password *
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      onCopy={(e) => {
                        e.preventDefault();
                        setErrors((prev) => ({
                          ...prev,
                          confirmPassword: "copy is not allowed for security resons",
                        }));
                      }}
                      onCut={(e) => {
                        e.preventDefault();
                        setErrors((prev) => ({
                          ...prev,
                          confirmpassword: "Cut is not allowed for security reasons",
                        }));
                      }}
                       onPaste={(e) => {
                        e.preventDefault();
                        setErrors((prev) => ({
                          ...prev,
                          confirmpassword: "Copy & paste is not allowed",
                        }));
                      }}
                       onDrop={(e) => e.preventDefault()}
                      autoComplete="new-password"
                      maxLength={20}
                      placeholder="Confirm password"
                      className={`w-full px-2 py-2.5 pr-10 border ${
                        errors.confirmPassword
                          ? "border-red-300"
                          : "border-gray-300"
                      } rounded-lg`}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                    >
                      {showConfirmPassword ? (
                        <EyeOff size={18} />
                      ) : (
                        <Eye size={18} />
                      )}
                    </button>
                  </div>
                  <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                    {errors.confirmPassword || "\u00A0"}
                  </p>
                </div>
              </div>

              {/* PUROHIT  and Temple Seva EXTRA FIELDS */}
              {formData.accountType === "purohit"  && (
                <div className="space-y-4 border-t pt-4">
                  {/* ADDRESS */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Address *
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      maxLength={50}
                      placeholder="Enter address"
                      className={`w-full px-4 py-2.5 border ${
                        errors.address ? "border-red-300" : "border-gray-300"
                      } rounded-lg`}
                    />
                    <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                      {errors.address || "\u00A0"}
                    </p>
                  </div>

                  {/* CITY + pincode */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* CITY */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        City *
                      </label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        maxLength={50}
                        placeholder="Enter city"
                        className={`w-full px-4 py-2.5 border ${
                          errors.city ? "border-red-300" : "border-gray-300"
                        } rounded-lg`}
                      />
                      <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                        {errors.city || "\u00A0"}
                      </p>
                    </div>

                    {/* PIN CODE */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        PIN Code *
                      </label>
                      <input
                        type="text"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                        maxLength={6}
                        placeholder="Enter 6-digit PIN"
                        className={`w-full px-4 py-2.5 border ${
                          errors.pincode ? "border-red-300" : "border-gray-300"
                        } rounded-lg`}
                      />
                      <p className="text-red-500 text-xs mt-1 min-h-[18px]">
                        {errors.pincode || "\u00A0"}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* SUBMIT BUTTON */}
              <button
                type="submit"
                className="w-full py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg font-semibold hover:from-orange-600 hover:to-red-600 transition-all"
              >
                Continue to Terms & Conditions
              </button>
            </form>

            <p className="text-center text-sm text-gray-500 mt-2">
              Already have an account?{" "}
              <span
                className="text-orange-500 font-medium cursor-pointer hover:underline"
                onClick={() => navigate("/login")}
              >
                Sign in here
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
